import { FirestoreService } from "../../../../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../../api/firebase/references";
import {
  BucketDoc,
  FirstStpBucketConfigResponse,
} from "../data-model/bucketModel";

const BUCKET_COLLECTION = "api_config/pharmacy/first-stp-outcome-bucketing";
const BUCKET_DOC_ID = "v1";

export const fetchBucketConfig = async (): Promise<BucketDoc[]> => {
  const docPath = FirestoreDocumentReference.firstStpOutcomeBucketing();
  const result =
    await FirestoreService.getDocument<FirstStpBucketConfigResponse>(docPath);
  return Array.isArray(result?.buckets) ? result.buckets : [];
};

export const saveBuckets = async (buckets: BucketDoc[]): Promise<void> => {
  await FirestoreService.updateDocument(BUCKET_COLLECTION, BUCKET_DOC_ID, {
    buckets,
  });
};
